/* Remove the grey plinth the model stands on.
   --------------------------------------------------------------------------
   The slab under the bike is not scene furniture, so it can't be removed the
   way builder-light.js removes its own pmStageFloor - it is a mesh baked into
   the GLB, named "Plane", carrying the logo artwork. It has to be hidden on
   the model itself.

   Run in a loop rather than once, for the same reason builder-parts.js does:
   the section re-materialises parts when options change, and the model isn't
   in the scene until three.js has finished downloading and parsing. A traverse
   of 40 meshes every 250ms is nothing next to the render loop.

   Exposed as __pmPlatform so the slab can be put back from the console
   (__pmPlatform.show()) without a redeploy, if it ever turns out to be wanted
   for a product shot. */
(function builderPlatform() {
  var PLANE = /^plane$/i;

  function set(visible) {
    var s = window.__pmScene;
    if (!s || !s.model) return false;
    var found = false;
    s.model.traverse(function (o) {
      if (o.isMesh && PLANE.test(o.name || '')) {
        o.visible = visible;
        found = true;
      }
    });
    return found;
  }

  function hide() {
    return set(false);
  }

  hide();

  var tries = 0;
  var poll = window.setInterval(function () {
    tries++;
    hide();
    if (tries > 240) window.clearInterval(poll); /* give up after ~60s */
  }, 250);

  window.__pmPlatform = {
    hide: hide,
    show: function () {
      return set(true);
    },
  };
})();